function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.008,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30.008 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.008,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.008,7.5h30v15H.008V7.5Z",
    style: {
      fill: "#215b33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.008,22.5V7.5h30",
    style: {
      fill: "#0051ba"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.008 7.504 30.007 7.5 28.458 7.5 .008 21.725 .008 22.5 1.476 22.5 30.008 8.234 30.008 7.504",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.595 11.537 5.258 10.5 4.921 11.537 3.832 11.537 4.713 12.177 4.377 13.214 5.258 12.573 6.14 13.214 5.804 12.177 6.685 11.537 5.595 11.537",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.675 9.639 7.338 10.676 8.219 10.036 9.101 10.676 8.764 9.639 9.647 8.999 8.556 8.999 8.219 7.962 7.883 8.999 6.793 8.999 7.675 9.639",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.556 14.075 8.219 13.038 7.883 14.075 6.793 14.075 7.675 14.715 7.338 15.752 8.219 15.112 9.101 15.752 8.764 14.715 9.647 14.075 8.556 14.075",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2.634 14.075 2.298 13.038 1.961 14.075 .87 14.075 1.752 14.715 1.415 15.752 2.297 15.112 3.179 15.752 2.842 14.715 3.724 14.075 2.634 14.075",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2.298 7.962 1.961 8.999 .87 8.999 1.752 9.639 1.415 10.676 2.297 10.035 3.179 10.676 2.842 9.639 3.724 8.999 2.634 8.999 2.298 7.962",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/SB.7f6dcd1fdbe68686387803aa0287bfb6.svg";
export { ForwardRef as ReactComponent };